// extracted by mini-css-extract-plugin
module.exports = {"loading-section":"loading-section_loading-section__39o4V"};